let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a0NCx")).then(() => parcelRequire('2Vw4P'));